const primaryInfo = {
    fields: [
        {
            name: 'id',
            label: 'id',
            validators: {}
        },
        {
            name: 'addressId',
            label: 'Location',
        },
        {
            name: 'permitHolder',
            label: 'Permit Holder',
            validators: {}
        },
        {
            name: 'permitNumber',
            label: 'Permit Number',
            validators: { required: true, }
        },
        {
            name: 'alarmTypeId',
            label: 'Alarm Type',
        },
        {
            name: 'alarmTransmissionMethodId',
            label: 'Transmission Method',
            validators: {}
        },
        {
            name: 'alarmCompanyName',
            label: 'Company Name',
            validators: {}
        },
        {
            name: 'alarmCompanyPhone',
            label: 'Phone',
            validators: {}
        },
        {
            name: 'alarmCompanyPhoneSuffix',
            label: 'Ext.',
            validators: {}
        }
    ],
    customFields: []
}

const registrations = {
    fields: [
        {
            name: 'id',
            validators: {
            }
        },
        {
            name: 'startDate',
            label: 'Start Date',
            validators: {
                required: true
            }
        },
        {
            name: 'endDate',
            label: 'End Date',
            validators: {

            }
        },
        {
            name: 'isPaid',
            label: 'Paid'
        },
        {
            name: 'paidDate',
            label: 'Payment Date',
            validators: {
            }
        },
        {
            name: 'isActive',
            label: 'Active',
            validators: {
                required: true
            }
        },
        {
            name: 'isRevoked',
            label: 'Revoked',
            validators: {
            }
        },
        {
            name: 'revokedDate',
            label: 'Revoked Date',
            validators: {
            }
        },
        {
            name: 'dueDate',
            label: 'Due Date',
            validators: {
            }
        },
        {
            name: 'registrationFee',
            label: 'Registration Fee',
            validators: {
            }
        },
        {
            name: 'isEditable',
            validators: {
            }
        },
    ],
    customFields: []
};



const alarmResponse = {
    fields: [
        {
            name: 'id',
            validators: {
            }
        },
        {
            name: 'isBillable',
            label: 'Billable',
            validators: {

            }
        },
        {
            name: 'billableAmount',
            label: 'billableAmount'
        },
        {
            name: 'falseAlarmSequence',
            label: 'False Alarm #',
            validators: {
            }
        },
        {
            name: 'billSentDate',
            label: 'Bill Sent Date',
            validators: {
                required: true
            }
        },
        {
            name: 'secondNoticeSentDate',
            label: 'Second Notice Sent Date',
            validators: {
            }
        },
        {
            name: 'thirdNoticeSentDate',
            label: 'Third Notice Sent Date',
            validators: {
            }
        },
        {
            name: 'isPaid',
            label: 'Paid',
            validators: {
            }
        },
        {
            name: 'paidDate',
            label: 'Payment Date',
            validators: {
            }
        },
        {
            name: 'comment',
            label: 'comment',
            validators: {
            }
        },
        {
            name:' alarmPermitId',
            label: 'Linked Alarm Permit',
            validators: {
            }
        }
    ],
    customFields: []
};

export const alarmPermitPrimaryInfoFields = {
    fields: [...primaryInfo.fields],
    customFields: [...primaryInfo.customFields]
}

export const alarmPermitRegistrationFields = {
    fields: [...registrations.fields],
    customFields: [...registrations.customFields]
}


export const alarmResponseFields = {
    fields: [...alarmResponse.fields],
    customFields: [...alarmResponse.customFields]
}


